import { Box, Divider, Grid } from "@chakra-ui/react";
import { MotionBox, appearBelow } from "utils/motion";
import Text from "components/base/Text";
import Trans from "components/base/Trans";
import Container from "components/base/Container";

const TableLine = ({ label, value }) => (
  <Box py={[4, null, 6]}>
    <Text type="title_xs" color="gray.400">
      <Trans id={label} />
    </Text>
    <Text type="p_md" color="white">
      <Trans id={value} />
    </Text>
  </Box>
);

const SpecRow = ({ left, right }) => (
  <Box>
    <Divider borderColor="gray.600" opacity={1} />
    <Grid templateColumns={right ? "1fr 1fr" : "1fr"} gap={[4, null, 8]}>
      <TableLine label={left.label} value={left.value} />
      {right && <TableLine label={right.label} value={right.value} />}
    </Grid>
  </Box>
);

export default function SpecsTable({ center, ...props }) {
  return (
    <Box width="100%" bg="black.900" color="white" {...props}>
      <Container>
        <MotionBox
          variants={appearBelow}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          width="100%"
          mx="auto"
          pt={["xl", null, "xxl"]}
          pb={["lg", null, "xl"]}
        >
          <Box mb={[6, null, 8]}>
            <Text type="title_xs" color="primary" mb={[1, null, 2]}>
              <Trans id="LBL_SPECS_SUBTITLE" />
            </Text>
            <Text type="headline_md" color="white">
              <Trans id="LBL_SPECS_TITLE" />
            </Text>
          </Box>

          <SpecRow
            left={{ label: "LBL_SPEC_LABEL_1", value: "LBL_SPEC_VALUE_1" }}
            right={{ label: "LBL_SPEC_LABEL_2", value: "LBL_SPEC_VALUE_2" }}
          />
          <SpecRow
            left={{ label: "LBL_SPEC_LABEL_3", value: "LBL_SPEC_VALUE_3" }}
            right={{ label: "LBL_SPEC_LABEL_4", value: "LBL_SPEC_VALUE_4" }}
          />
          <SpecRow
            left={{ label: "LBL_SPEC_LABEL_5", value: "LBL_SPEC_VALUE_5" }}
            right={{
              label: "LBL_TECHSPEC_LABEL_1",
              value: "LBL_TECHSPEC_VALUE_1",
            }}
          />
          <SpecRow
            left={{
              label: "LBL_TECHSPEC_LABEL_4",
              value: "LBL_TECHSPEC_VALUE_4",
            }}
            right={{ label: "LBL_SPEC_LABEL_6", value: "LBL_SPEC_VALUE_6" }}
          />
          <SpecRow
            left={{ label: "LBL_SPEC_LABEL_7", value: "LBL_SPEC_VALUE_7" }}
            right={{ label: "LBL_SPEC_LABEL_8", value: "LBL_SPEC_VALUE_8" }}
          />
          <SpecRow
            left={{ label: "LBL_SPEC_LABEL_9", value: "LBL_SPEC_VALUE_9" }}
            right={{
              label: "LBL_TECHSPEC_LABEL_3",
              value: "LBL_TECHSPEC_VALUE_3",
            }}
          />

          <Divider borderColor="gray.600" opacity={1} />
        </MotionBox>
      </Container>
    </Box>
  );
}
